import "./TablaUsuariosEmpleados.css";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import ModalBancoAdmin from "./ModalBancoAdmin";
import { getToken } from "../../utils/auth";


const TablaBancosAdmin = () => {
    const { darkMode } = useContext(DarkModeContext);
    const [bancos, setBancos] = useState([]);
    const [filtro, setFiltro] = useState("");
    const [modalAbierto, setModalAbierto] = useState(false);
    const [bancoSeleccionado, setBancoSeleccionado] = useState(null);

    const cargarBancos = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_API_BANCOS);
            const data = await response.json();
            setBancos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error fetching bancos:", error);
        }
    };

    useEffect(() => {
        cargarBancos();
    }, []);

    const bancosFiltrados = useMemo(() => {
        const termino = filtro.trim().toLowerCase();
        if (!termino) {
            return bancos;
        }

        return bancos.filter((banco) =>
            `${banco.codBanco ?? ""} ${banco.nomBanco ?? ""}`.toLowerCase().includes(termino)
        );
    }, [bancos, filtro]);

    const eliminarBanco = async (banco) => {
        const token = getToken();
        if (!token) {
            return;
        }

        const confirmacion = await Swal.fire({
            title: "Eliminar banco",
            text: `Se eliminara ${banco.nomBanco}.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            customClass: {
                container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                confirmButton: "my-swal-button",
            },
        });

        if (!confirmacion.isConfirmed) {
            return;
        }

        try {
            const response = await fetch(process.env.REACT_APP_API_BANCO_ELIMINAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    CodBanco: banco.codBanco,
                }),
            });

            const text = await response.text();
            if (!response.ok) {
                throw new Error(text || "No se pudo eliminar el banco.");
            }

            await cargarBancos();
            Swal.fire("Eliminado", "El banco fue eliminado correctamente.", "success");
        } catch (error) {
            Swal.fire("Error", error.message || "No se pudo eliminar el banco.", "error");
        }
    };

    return (
        <div className={darkMode ? "container bg-tabla-usuarios-liquidaciones-dark" : "container bg-tabla-usuarios-liquidaciones"}>
            <section className="container mt-3 mb-3">
                <div className="d-flex flex-wrap justify-content-between">
                    <div className="margin-centrado-responsive">
                        <div className="my-3 d-flex">
                            <h6 className="my-3 me-3 fs-18-a-16">Bancos</h6>
                            <div className="campo-busqueda">
                                <Form.Group className="d-flex justify-content-center">
                                    <Form.Control
                                        className={
                                            darkMode
                                                ? "form-control text-white label-buscador-dark lato-regular fs-18 border-0"
                                                : "form-control label-buscador lato-regular fs-18 border-0"
                                        }
                                        type="text"
                                        placeholder="Buscar banco"
                                        value={filtro}
                                        onChange={(e) => setFiltro(e.target.value)}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex centrado-responsive pt-3">
                        <article className="d-flex justify-content-end">
                            <Button
                                className="centrado border-0 btn btn-modal-nuevo-usuario-editar centrado border-0 mx-2"
                                onClick={() => {
                                    setBancoSeleccionado(null);
                                    setModalAbierto(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faCirclePlus} />
                                <span className="lato-bold fs-18 ms-2">Nuevo</span>
                            </Button>
                        </article>
                    </div>
                </div>
            </section>

            <article>
                <div className="container table-responsive py-3 px-5">
                    <table className="table table-borderless responsive striped hover">
                        <thead className="border-0">
                            <tr className="text-center tabla-thead">
                                <th className={darkMode ? "bg-white text-dark border-tabla-izquierda border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-tabla-izquierda border-0 lato-regular fs-12 py-3"}>ID</th>
                                <th className={darkMode ? "bg-white text-dark border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Banco</th>
                                <th className={darkMode ? "bg-white text-dark border-0 lato-regular fs-12 py-3" : "bg-dark text-white border-0 lato-regular fs-12 py-3"}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {bancosFiltrados.length > 0 ? (
                                bancosFiltrados.map((banco) => (
                                    <tr key={banco.codBanco} className={darkMode ? "tabla-borde-bottom text-white" : "tabla-borde-bottom text-dark"}>
                                        <td className="fs-12-a-10 lato-regular pt-4">{banco.codBanco}</td>
                                        <td className="fs-12-a-10 lato-regular pt-4">{banco.nomBanco}</td>
                                        <td className="fs-12-a-10 lato-regular pt-3">
                                            <button
                                                className="btn btn-sm btn-outline-secondary me-2"
                                                onClick={() => {
                                                    setBancoSeleccionado(banco);
                                                    setModalAbierto(true);
                                                }}
                                            >
                                                Editar
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => eliminarBanco(banco)}
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="lato-bold fs-12-a-10">
                                        No se encontraron bancos.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </article>

            <ModalBancoAdmin
                show={modalAbierto}
                onHide={() => setModalAbierto(false)}
                banco={bancoSeleccionado}
                onSuccess={cargarBancos}
            />
        </div>
    );
};

export default TablaBancosAdmin;
